const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const GlobalSmsRateLimitQuery: any = {
    GetRateLimitSummary: Backofficebff + '/v1/globalsmsratelimit/rate-limit-summary',
    GetCountryLimitByPlatform: Backofficebff + '/v1/globalsmsratelimit/country-limit-by-platform',
    GetCountryLimitHistory: Backofficebff + '/v1/globalsmsratelimit/country-limit-history',
    GetCountryLimit: Backofficebff + '/country-limit',
};
